module.exports = __webpack_public_path__ + "img/70.291d8eef.jpg";